import { Select, SelectItem } from '@nextui-org/react';
import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

interface StatusOption {
  key: string;
  label: string;
  color: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
}

interface StatusFilterProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  options: StatusOption[];
}

const StatusFilter = ({
  className = 'min-w-32',
  size = 'sm',
  label,
  placeholder,
  value,
  onChange,
  options,
}: StatusFilterProps) => {
  const { t } = useTranslation('common');

  const renderSelectItems = () => {
    return [

      ...options.map((status) => (
        <SelectItem key={status.key} value={status.key}>
          {status.label}
        </SelectItem>
      ))
    ];
  };

  const finalLabel = label || t('Estado');
  const finalPlaceholder = placeholder || t('Seleccionar estado');

  return (
    <Select
      label={finalLabel}
      placeholder={finalPlaceholder}
      selectedKeys={value ? [value] : []}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      size={size}
      aria-label={`${t('Selecciona')} ${finalLabel.toLowerCase()}`}
    >
      {renderSelectItems()}
    </Select>
  );
};

export default StatusFilter; 